<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              Cadastrar Categorias
              <span class="required_fields"
                ><span class="required">*</span> Campos obrigatórios</span
              >
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <form action="">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="catName"
                          ><span class="required">*</span> Nome da
                          Categoria</label
                        >
                        <input
                          type="text"
                          v-model="category.description"
                          class="form-control"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                  <div class="card-subtitle mt-2 mb-2">
                    Cadastrar Imagens de Avaliação
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="catPic01">Imagem Traseira</label>
                        <input
                          type="file"
                          id="back_photo"
                          name="back_photo"
                          class="form-control"
                          accept="image/*"
                          placeholder=""
                        />
                        <small class="input-help"
                          >A imagem deve ter 400px de Largura</small
                        >
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="catPic02">Imagem Lateral Esquerda</label>
                        <input
                          type="file"
                          id="left_side_photo"
                          name="left_side_photo"
                          class="form-control"
                          accept="image/*"
                          placeholder=""
                        />
                        <small class="input-help"
                          >A imagem deve ter 340px de Largura</small
                        >
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="catPic03">Imagem Teto</label>
                        <input
                          type="file"
                          id="ceiling_photo"
                          name="ceiling_photo"
                          class="form-control"
                          accept="image/*"
                          placeholder=""
                        />
                        <small class="input-help"
                          >A imagem deve ter 400px de Largura</small
                        >
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="catPic04">Imagem Lateral Direita</label>
                        <input
                          type="file"
                          id="right_side_photo"
                          name="right_side_photo"
                          class="form-control"
                          accept="image/*"
                          placeholder=""
                        />
                        <small class="input-help"
                          >A imagem deve ter 340px de Largura</small
                        >
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="catPic05">Imagem Frontal</label>
                        <input
                          type="file"
                          id="front_photo"
                          name="front_photo"
                          class="form-control"
                          accept="image/*"
                          placeholder=""
                        />
                        <small class="input-help"
                          >A imagem deve ter 400px de Largura</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="card-subtitle mt-2 mb-2">
                    <span class="required">*</span> Tipos de Avaria
                  </div>
                  <div class="row">
                    <div class="col-md-10">
                      <div class="form-group">
                        <label for="catDmg">Novo Tipo de Avaria</label>
                        <input
                          type="text"
                          v-model="breakdown_type.description"
                          class="form-control"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <button
                        type="button"
                        class="btn btn-add btn-block mt-4"
                        @click="save_breakdown_type"
                      >
                        Cadastrar Novo
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      :key="b.id"
                      v-for="(b, indexs) in breakdown_types"
                      class="col-md-4"
                    >
                      <div class="car-add">
                        <div class="add-type">{{ b.description }}</div>
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="b.id + 'b'"
                            v-model="b.status"
                            :value="b.id"
                            @change="edit_breakdown_type(indexs)"
                          />
                          <a @click="modalEditBreakdown(indexs)"
                            ><i
                              class="far fa-edit"
                              style="padding-right: 50px"
                            ></i
                          ></a>
                          <label
                            class="custom-control-label"
                            :for="b.id + 'b'"
                          ></label>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                  <div class="card-subtitle mt-5 mb-2">
                    <span class="required">*</span> Adicionais Para a Check-List
                  </div>
                  <div class="row">
                    <div class="col-md-10">
                      <div class="form-group">
                        <label for="catAdd">Novo Item Adicional</label>
                        <input
                          type="text"
                          v-model="checklist_item.description"
                          class="form-control"
                          id="catAdd"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <button
                        type="button"
                        class="btn btn-add btn-block mt-4"
                        @click="save_checklist_item"
                      >
                        Cadastrar Novo
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      :key="c.id"
                      v-for="(c, index) in checklist_items"
                      class="col-md-4"
                    >
                      <div class="car-add">
                        <div class="add-type">{{ c.description }}</div>
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="c.id + 'c'"
                            v-model="c.status"
                            @change="edit_checklist_item(index)"
                            :value="c.id"
                          /><a @click="modalEditChecklist(index)"
                            ><i
                              class="far fa-edit"
                              style="padding-right: 50px"
                            ></i
                          ></a>
                          <label
                            class="custom-control-label"
                            :for="c.id + 'c'"
                          ></label>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <a class="btn btn-add" @click="save">
                    Salvar <i class="fa fa-save"></i>
                  </a>
                  <router-link to="/categories" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                </form>
              </div>
              <div class="col-md-3">
                <div class="damage-img">
                  <div class="back">
                    <img
                      class="img01"
                      src="../../assets/images/traseira.png"
                      alt=""
                    />
                  </div>
                  <div class="middle">
                    <img
                      class="img02"
                      src="../../assets/images/lateral-esquerda.png"
                      alt=""
                    />
                    <img
                      class="img03"
                      src="../../assets/images/teto.png"
                      alt=""
                    />
                    <img
                      class="img04"
                      src="../../assets/images/lateral-direita.png"
                      alt=""
                    />
                  </div>
                  <div class="front">
                    <img
                      class="img05"
                      src="../../assets/images/frontal.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Breakdown -->
      <div
        class="modal fade"
        id="modalBreakdown"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalBreakdownTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalBreakdownTitle">
                Edição dos Dados - Tipo de Avaria
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="catAdd">Tipo de Avaria</label>
                    <input
                      type="text"
                      v-model="breakdown_types[indexs].description"
                      class="form-control"
                      id="catAdd"
                      placeholder=""
                    />
                  </div>
                </div>
                <div class="col-md-12" style="margin-left: -35px">
                  <div class="custom-control custom-switch">
                    <div class="row">
                      <div class="col-md-3">Gerar pendência?</div>
                      <div class="col-md-6 ml-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="breakdown_types[indexs].id + 'bcc'"
                          v-model="breakdown_types[indexs].divergence"
                        />
                        <label
                          class="custom-control-label"
                          :for="breakdown_types[indexs].id + 'bcc'"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="col-md-12" style="margin-left: -35px">
                  <div class="custom-control custom-switch">
                    <div class="row">
                      <div class="col-md-3">Exibir no APP?</div>
                      <div class="col-md-6 ml-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="breakdown_types[indexs].id + 'bccs'"
                          v-model="breakdown_types[indexs].status"
                        />
                        <label
                          class="custom-control-label"
                          :for="breakdown_types[indexs].id + 'bccs'"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="col-md-3">
                  <button
                    type="button"
                    class="btn btn-add btn-block mt-4"
                    @click="edit_breakdown_type(indexs)"
                  >
                    Salvar Alterações
                  </button>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-1">
                  <button
                    type="button"
                    class="btn btn-crud delete"
                    @click="destroyBreakdownTypes(indexs)"
                    data-tooltip="tooltip"
                    title="Excluir"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Checklist -->
      <div
        class="modal fade"
        id="modalChecklist"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalChecklistTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalChecklistTitle">
                Edição dos Dados - Item de Checklist
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-9">
                  <div class="form-group">
                    <label for="catAdd">Item de Checklist</label>
                    <input
                      type="text"
                      v-model="checklist_items[index].description"
                      class="form-control"
                      id="catAdd"
                      placeholder=""
                    />
                  </div>
                </div>
                <div class="col-md-12" style="margin-left: -35px">
                  <div class="custom-control custom-switch">
                    <div class="row">
                      <div class="col-md-3">Gerar pendência?</div>
                      <div class="col-md-6 ml-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="checklist_items[index].id + 'bbc'"
                          v-model="checklist_items[index].divergence"
                        />
                        <label
                          class="custom-control-label"
                          :for="checklist_items[index].id + 'bbc'"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="col-md-12" style="margin-left: -35px">
                  <div class="custom-control custom-switch">
                    <div class="row">
                      <div class="col-md-3">Exibir no APP?</div>
                      <div class="col-md-6 ml-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="checklist_items[index].id + 'bbcs'"
                          v-model="checklist_items[index].status"
                        />
                        <label
                          class="custom-control-label"
                          :for="checklist_items[index].id + 'bbcs'"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="col-md-3">
                  <button
                    type="button"
                    class="btn btn-add btn-block mt-2"
                    @click="edit_checklist_item(index)"
                  >
                    Salvar Alterações
                  </button>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-3">
                  <button
                    type="button"
                    class="btn btn-crud delete"
                    @click="destroyChecklistItems(index)"
                    data-tooltip="tooltip"
                    title="Excluir"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      category: {
        description: "",
        breakdown_types_id: "",
        checklist_item_id: "",
        back_photo: "",
        left_side_photo: "",
        right_side_photo: "",
        ceiling_photo: "",
        front_photo: "",
      },
      breakdown_type: {
        description: "",
        checked: "",
      },
      checklist_item: {
        description: "",
        checked: "",
      },
      breakdown_types: [
        {
          description: "",
        },
      ],
      checklist_items: [
        {
          description: "",
        },
      ],
      checked: [],
      checked_b: [],
      breakdown_items: [],
      index: 0,
      indexs: 0,
    };
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let back_photo = document.getElementById("back_photo");
      let left_side_photo = document.getElementById("left_side_photo");
      let right_side_photo = document.getElementById("right_side_photo");
      let ceiling_photo = document.getElementById("ceiling_photo");
      let front_photo = document.getElementById("front_photo");

      fd.append("description", self.category.description);
      fd.append("breakdown_types_id", self.category.breakdown_types_id);
      fd.append("checklist_item_id", self.category.checklist_item_id);
      fd.append("back_photo", back_photo.files[0] ? back_photo.files[0] : "");
      fd.append(
        "left_side_photo",
        left_side_photo.files[0] ? left_side_photo.files[0] : ""
      );
      fd.append(
        "right_side_photo",
        right_side_photo.files[0] ? right_side_photo.files[0] : ""
      );
      fd.append(
        "ceiling_photo",
        ceiling_photo.files[0] ? ceiling_photo.files[0] : ""
      );
      fd.append(
        "front_photo",
        front_photo.files[0] ? front_photo.files[0] : ""
      );
      fd.append("breakdown_types", self.checked_b);
      fd.append("checklist_items", self.checked);

      if (self.category.id) {
        fd.append("id", self.category.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "categories";

      let fd = self.makeFormData();

      if (self.category.id) {
        api += "/" + self.category.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/categories");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    modalEditChecklist(id) {
      const self = this;
      self.index = id;

      $("#modalChecklist").modal({ show: true });
    },

    modalEditBreakdown(id) {
      const self = this;
      self.indexs = id;

      $("#modalBreakdown").modal({ show: true });
    },
    save_breakdown_type: function () {
      const self = this;
      let api = self.$store.state.api + "breakdownTypes";

      let fd = new FormData();

      fd.append("description", self.breakdown_type.description);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.getBreakdownTypes();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    edit_breakdown_type(id) {
      const self = this;
      let api =
        self.$store.state.api + "breakdownTypes/" + self.breakdown_types[id].id;

      let fd = new FormData();

      fd.append("_method", "put");
      fd.append("description", self.breakdown_types[id].description);
      fd.append("status", self.breakdown_types[id].status == false ? 0 : 1);
      fd.append(
        "divergence",
        self.breakdown_types[id].divergence == false ? 0 : 1
      );

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          $("#modalBreakdown").modal("hide");
          self.getChecklistItems();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    destroyBreakdownTypes(id) {
      const self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;

          case "confirm":
            const api =
              self.$store.state.api +
              "breakdownTypes/" +
              self.breakdown_types[id].id;

            self.$http
              .delete(api)

              .then((response) => {
                swal("Sucesso", "Registro excluído com sucesso!", "success");
                location.reload();
              });

            break;
        }
      });
    },

    save_checklist_item: function () {
      const self = this;
      let api = self.$store.state.api + "checklistItems";

      let fd = new FormData();

      fd.append("description", self.checklist_item.description);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.getChecklistItems();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    edit_checklist_item(id) {
      const self = this;
      let api =
        self.$store.state.api + "checklistItems/" + self.checklist_items[id].id;

      let fd = new FormData();

      fd.append("_method", "put");
      fd.append("description", self.checklist_items[id].description);
      fd.append("status", self.checklist_items[id].status == false ? 0 : 1);
      fd.append(
        "divergence",
        self.checklist_items[id].divergence == false ? 0 : 1
      );

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          $("#modalChecklist").modal("hide");
          self.getChecklistItems();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    destroyChecklistItems(id) {
      const self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;

          case "confirm":
            const api =
              self.$store.state.api +
              "checklistItems/" +
              self.checklist_items[id].id;

            self.$http
              .delete(api)

              .then((response) => {
                swal("Sucesso", "Registro excluído com sucesso!", "success");
                location.reload();
              });

            break;
        }
      });
    },
    getCategory: function (id) {
      const self = this;
      const api = self.$store.state.api + "categories/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.category = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBreakdownTypes: function (id) {
      const self = this;
      const api = self.$store.state.api + "breakdownTypes/";

      self.$http
        .get(api)
        .then((response) => {
          let breakdown_types = response.data.data;
          for (let i = 0; i < breakdown_types.length; i++) {
            breakdown_types[i].checked = false;
          }
          self.breakdown_types = breakdown_types;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getChecklistItems: function (id) {
      const self = this;
      const api = self.$store.state.api + "checklistItems/";

      self.$http
        .get(api)
        .then((response) => {
          let checklist_items = response.data.data;

          self.checklist_items = checklist_items;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCheckeds: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "link_category_checklist_items/?category_id=" +
        id;

      self.$http
        .get(api)
        .then((response) => {
          let checked_items = response.data.data;
          for (let i = 0; i < checked_items.length; i++) {
            self.checked[i] = checked_items[i].checklist_item_id;
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCheckeds_b: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "link_category_breakdown_types/?category_id=" +
        id;

      self.$http
        .get(api)
        .then((response) => {
          let breakdown_items = response.data.data;
          for (let i = 0; i < breakdown_items.length; i++) {
            self.checked_b[i] = breakdown_items[i].breakdown_types_id;
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getBreakdownTypes();
    self.getChecklistItems();
    let id = self.$route.params.id;

    self.getCheckeds(id);
    self.getCheckeds_b(id);
    if (id) {
      self.getCategory(id);
    }
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Category/Add.vue